<div fxLayout="row" fxFlexFill>
    <ckeditor #ckeditor name="textoLongo_{{pinRandom}}"
              fxFlex="100%"
              [config]="config"
              [(ngModel)]="conteudo.descricao" [readonly]="camposDesabilitados"></ckeditor>
</div>
<div fxLayout="row" fxFlexFill *ngIf="!camposDesabilitados">
    <div fxLayout="column">
        <div ngModelGroup="comboConsultaBancoTexto_{{pinRandom}}" fxFlexFill>
            <combo-consulta-banco [showDisplayId]="false"
                                  [obrigatorio]="false"
                                  [selecionado]="valorSelecionado"
                                  [label]="'Valor'"
                                  (valorChange)="onValorSelecionado($event)"
                                  [tipoConsulta]="'U'">
            </combo-consulta-banco>
        </div>
    </div>
    <div fxLayout="column">
        <div fxLayoutAlign="start center" fxLayoutGap="16px"
             style="padding-top: 10px; padding-left: 20px;">
            <div>
                <button matTooltip="Adicionar Valor" mat-mini-fab color="primary"
                        (click)="addValoreSelecionado()"
                        style="width: 150px;border-radius: 5px;" [disabled]="!valorSelecionado">
                    <mat-icon>add</mat-icon>
                    Adicionar Valor
                </button>
            </div>
        </div>
    </div>
    <div fxLayout="column">
        <div fxLayoutAlign="start center" fxLayoutGap="16px"
             style="padding-top: 10px; padding-left: 20px;">
            <div>
                <button matTooltip="Nova Linha" mat-mini-fab color="primary"
                        (click)="copiarValorParaCopyPaste()"
                        style="width: 130px;border-radius: 5px"
                        [disabled]="!valorSelecionado">
                    <mat-icon>add</mat-icon>
                    Copiar Valor
                </button>
            </div>
        </div>
    </div>
</div>